import React from "react";
import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

let WSID = null;
export const TYPES = {
    cUpdate: 'ColumnUpdate',
    cardNovo: 'CardNew',
    cardMove: 'CardMove',
    cardMoveOutraColuna: 'CardMoveColuna',
    cardsMoveOutraColuna:'CardsMoveColuna',
    cardChangeOrdem: 'CardChangeOrder',
    cardAddMembro: 'AddMembroCartao',
    cardToggleMembro: 'ToggleMembroCartao',
    etiqueta: 'Etiqueta',
    cardMudaNome: 'MudaNomeCartao',
    templateCopiado: "TemplateCopiado",
    cardConcluido: 'CartaoConcluido',
    cardArquivar: 'CartaoArquivar'
}
const ServiceWS = () => {
    const [wsDado, setWsDado] = React.useState([]);
    const [stompClient, setStompClient] = React.useState(null);
   
    // const [WSID, setWSID] = React.useState(null);

    React.useEffect(() => {
        const client = conectar();
        return () => {
            console.log('>>>destruido<<<');
            setStompClient(null);
            client.deactivate();
        };
    }, []);

    // React.useEffect(() => {
    //     if( !stompClient ){
    //         console.log( 'segunda vez......')
    //         const client = conectar();
    //         return () => {
    //             console.log('>>>destruido<<<');
    //             setStompClient(null);
    //             client.deactivate();
    //         };
    //     }
    // }, [stompClient]);

    function conectar(){
        // console.log('>>>>construindo<<<<');
        // const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
        const socketUrl = window.info.wsSocketUrl;//`${protocol}://localhost:8080/ws`;

        const client = new Client({
            brokerURL: socketUrl, // WebSocket endpoint
            reconnectDelay: 5000,
            heartbeatIncoming: 4000,
            heartbeatOutgoing: 4000,
            // webSocketFactory: () => new SockJS('http://localhost:8080/ws'), // Fallback
            webSocketFactory: () => new SockJS(window.info.webSocketFactory), // Fallback
        });
        client.onConnect = () => {
            // console.log("Connected to WebSocket");
            client.subscribe('/topic/kanban', (message) => {
                
                const j = JSON.parse(message.body);
                if (j.id === WSID) return;
                
                setWsDado((prev) => [...prev, j.wrapper ? j.wrapper : j]);
            });
            WSID = crypto.randomUUID();
        };
        client.activate();
        setStompClient(client);
        return client
    }

    const cleanWsDado = () => {
        setWsDado([]);
    }
    const enviaDadoWS = (data) => {
        if (!WSID) {
            console.error(">>>>>WSID INVALIDO<<<<<");
            return;
        }
        if (stompClient && stompClient._checkConnection) {
            const dado = {
                id: WSID,
                wrapper: data,
            }
            try{
                stompClient.publish({
                    destination: '/app/projeto',
                    body: JSON.stringify(dado),
                    skipContentLengthHeader: true,
                });
            }catch(e){
                console.error( e );
                conectar();
                setTimeout(() => {
                    //enviando dado novamente.....
                    stompClient.publish({
                        destination: '/app/projeto',
                        body: JSON.stringify(dado),
                        skipContentLengthHeader: true,
                    });
                }, 600);
            }
        }
    };

    return [wsDado, enviaDadoWS, cleanWsDado, TYPES];
}

export default ServiceWS;